(function () {
  'use strict';

  var pendingUpdate = null;
  var refreshTimer = null;

  function getThresholdCents(container) {
    var threshold = parseFloat(container.dataset.freeShippingThreshold || '0');

    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      threshold = Math.round(threshold * window.Shopify.currency.rate);
    }

    return threshold;
  }

  function getShippingTotal(cart) {
    var items = cart.items || [];
    if (!items.length) return 0;

    var shippableItems = items.filter(function (item) {
      return item.requires_shipping !== false;
    });

    if (!shippableItems.length) return 0;

    if (shippableItems.length === items.length) {
      return cart.total_price;
    }

    var shippableTotal = shippableItems.reduce(function (sum, item) {
      return sum + item.final_line_price;
    }, 0);

    var allItemsTotal = items.reduce(function (sum, item) {
      return sum + item.final_line_price;
    }, 0);

    if (!allItemsTotal) return 0;

    return Math.round(cart.total_price * (shippableTotal / allItemsTotal));
  }

  function cartRequiresShipping(cart) {
    return (cart.items || []).some(function (item) {
      return item.requires_shipping !== false;
    });
  }

  function updateShippingOnly(cart) {
    var container = document.querySelector('cart-drawer .cart-drawer__shipping-savings');
    if (!container || !cart) return;

    var threshold = getThresholdCents(container);
    var shippingRow = container.querySelector('.cart-drawer__shipping-row');
    var shippingValue = container.querySelector('.cart-drawer__shipping-value');
    var shippingTotal = getShippingTotal(cart);
    var qualifiesForFree = shippingTotal >= threshold;
    var requiresShipping = cartRequiresShipping(cart);

    if (!shippingRow || !shippingValue) return;

    if (requiresShipping) {
      shippingRow.hidden = false;
      shippingValue.textContent = qualifiesForFree
        ? (container.dataset.shippingFree || 'Free')
        : (container.dataset.shippingAtCheckout || 'Calculated at checkout');
      shippingValue.classList.toggle('cart-drawer__shipping-value--at-checkout', !qualifiesForFree);
    } else {
      shippingRow.hidden = true;
    }
  }

  function refreshFromServer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    if (pendingUpdate) {
      pendingUpdate.abort();
    }

    pendingUpdate = new AbortController();

    return fetch(root + 'cart.js', { signal: pendingUpdate.signal })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateShippingOnly(cart);
        return cart;
      })
      .catch(function () {});
  }

  function scheduleShippingUpdate(eventCart) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      updateShippingOnly(eventCart);
      refreshFromServer();
    }, 600);
  }

  window.AerlessCartShipping = {
    update: updateShippingOnly,
    refresh: refreshFromServer
  };

  document.addEventListener('cart:change', function (event) {
    scheduleShippingUpdate(event.detail && event.detail.cart);
  });

  document.addEventListener('cart:refresh', function () {
    scheduleShippingUpdate();
  });

  function getLineItem(context) {
    return (
      context.closest('line-item') ||
      context.closest('tr')?.querySelector('line-item') ||
      null
    );
  }

  function getRemoveTrigger(event) {
    return event.target.closest('[data-cart-remove], a[href*="/cart/change"]');
  }

  function isCartRemoveContext(trigger) {
    return !!trigger.closest('cart-drawer, line-item, .shopify-section--main-cart, #cart-drawer');
  }

  async function changeLineItemQuantity(context, lineKey, targetQuantity, lineIndex) {
    var lineItem = getLineItem(context);
    var quantityInput = context.closest('line-item-quantity')?.querySelector('[data-line-key]') ||
      context.closest('line-item, tr')?.querySelector('[data-line-key]');

    lineItem?.dispatchEvent(
      new CustomEvent('line-item:will-change', {
        bubbles: true,
        detail: { targetQuantity: targetQuantity }
      })
    );

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var changePayload = { quantity: targetQuantity, sections: sectionsToBundle };
    if (lineKey) {
      changePayload.id = lineKey;
    } else if (lineIndex) {
      changePayload.line = lineIndex;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var response = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(changePayload)
    });

    if (!response.ok) {
      var responseContent = await response.json();
      var row = context.closest('.line-item, tr');
      row?.querySelector('[role="alert"]')?.remove();

      var errorHost = lineItem?.querySelector('.line-item__info') || row;
      if (errorHost) {
        var errorSvg =
          '<svg width="14" viewBox="0 0 18 18">' +
          '<path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#eb001b"></path>' +
          '<path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>' +
          '</svg>';
        errorHost.insertAdjacentHTML(
          'beforeend',
          '<p class="text-with-icon text-error text-xs" role="alert">' +
            errorSvg +
            ' ' +
            responseContent.description +
            '</p>'
        );
      }

      if (quantityInput) {
        quantityInput.value = quantityInput.defaultValue;
      }
      lineItem?.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
      return;
    }

    var cartContent = await response.json();

    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }

    var lineItemAfterChange = cartContent.items.filter(function (item) {
      return item.key === lineKey;
    });

    lineItem?.dispatchEvent(
      new CustomEvent('line-item:change', {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
          cart: cartContent
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart: cartContent
        }
      })
    );

    [700, 1600, 2800].forEach(function (delay) {
      window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }, delay);
    });
  }

  function handleCartRemove(event) {
    var trigger = getRemoveTrigger(event);
    if (!trigger || !isCartRemoveContext(trigger)) return;

    event.preventDefault();
    event.stopPropagation();

    var lineKey = trigger.getAttribute('data-line-key') ||
      trigger.closest('line-item-quantity, line-item, tr')?.querySelector('[data-line-key]')?.getAttribute('data-line-key');
    var lineIndex = trigger.getAttribute('data-line-index');
    var targetQuantity = 0;

    if (trigger.matches('a[href*="/cart/change"]')) {
      var url = new URL(trigger.href, window.location.origin);
      lineKey = lineKey || url.searchParams.get('id');
      lineIndex = lineIndex || url.searchParams.get('line');
      targetQuantity = parseInt(url.searchParams.get('quantity'), 10);
    }

    changeLineItemQuantity(
      trigger,
      lineKey,
      isNaN(targetQuantity) ? 0 : targetQuantity,
      lineIndex ? parseInt(lineIndex, 10) : null
    );
  }

  document.addEventListener('click', handleCartRemove, true);
})();
